import React from "react";
import CustomBadge from "./CustomBadge";
import { withStyles } from "@material-ui/core/styles";
import appConstants from "../../../../../../appConstants";
const styles = (theme) => ({
  divStyle: {
    display: "flex",
    justifyContent: "center",
  },
});
const ShipmentBadgeList = ({
  classes,
  bills,
  pieces,
  hu,
  weight,
  stopType,
  stc,
}) => (
  <div className={classes.divStyle}>
    {stopType === appConstants.STOP_TYPE.Pickup && (
      <CustomBadge value={bills ? bills : "-"} labelText="Bills" />
    )}
    <CustomBadge value={pieces ? pieces : "-"} labelText="Pieces" />
    {stopType === appConstants.STOP_TYPE.Delivery && (
      <CustomBadge value={stc ? stc : "-"} labelText="STC" />
    )}
    <CustomBadge value={hu ? hu : "-"} labelText="HU" />
    <CustomBadge value={weight ? weight : "-"} labelText="LBS" />
  </div>
);
export default withStyles(styles)(ShipmentBadgeList);
